module.exports = __webpack_public_path__ + "img/flowers_2.b1d1723c.png";